import { useState, useEffect } from "react"
import { Paper, TableContainer, Table, TableHead, TableRow, TableCell, TablePagination, TableBody } from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles'
import { useSelector, useDispatch } from "react-redux"
import { formatDinero } from "./../../../../utils/formatDinero"
import { FormatoFecha, FormatoFechaIso } from "./../../../../utils/FormatFecha"
import BackDrop from "../../../../global/BackDrop"
import { obtenerCortesCajaAction } from "./../../../../ducks/finanzasDuck"
import PickerMod from "../../../../global/PickersMod"
import DBCorte from "../DCorte"
const columns = [
    { id: "totalMovimientos", minWidth: 50, align: "center", label: "Total Movimientos" },
    { id: "totalMXN", minWidth: 50, align: "center", label: "Total MXN" },
    { id: "tcCompraUSD", minWidth: 50, align: "center", label: "T.C.C." },
    { id: "totalDolares", minWidth: 50, align: "center", label: "Total USD" },
    { id: "ganaciaTotalMXN", minWidth: 50, align: "center", label: "Ganacia Total USD" },
    { id: "fechaCorte", minWidth: 50, align: "center", label: "Fecha Corte" },
    { id: "detalles", minWidth: 50, align: "center", label: "Detalles" },
]

const useStyles = makeStyles({
    containerRoot: {
        marginTop: "25px",
        marginBottom: "25px"
    },
    containerRootButton: {
        marginTop: "25px",
        marginBottom: "25px",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center"
    },
    root: {
        width: '100%',
        padding: '0'
    },
    container: {
        maxHeight: 440,
    },
})

const TCortes = () => {
    const cortesCaja = useSelector(store => store.finanzas.cortesMovimeinto)
    const rows = cortesCaja
    const classes = useStyles()
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [load, setLoad] = useState(false)
    const [selectDayInicio, setSelectedDateInicio] = useState(new Date());
    const dispatch = useDispatch()

    useEffect(() => {
        setLoad(true)
        dispatch(obtenerCortesCajaAction({ FechaBusqueda: FormatoFecha({ date: selectDayInicio, formato: "MMddyyyy" }) }))
            .then(Response => {
                setLoad(false)
            })
    }, [dispatch, selectDayInicio])
    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value)
        setPage(0)
    }

    return (
        <div className={classes.containerRoot}>
            <div style={{ maxWidth: "30%", margin: "1% 0" }}>
                <PickerMod
                    id="desde"
                    label="Desde"
                    selectedDate={selectDayInicio}
                    setSelectedDate={setSelectedDateInicio}
                    disablePast={false}
                    disableFuture={true}
                />
            </div>
            <Paper className={classes.root}>
                <TableContainer className={classes.container}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                {columns.map((column) => (
                                    <TableCell
                                        key={column.id}
                                        align={column.align}
                                        style={{ minWidth: column.minWidth }}
                                    >
                                        {column.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
                                return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={row.IdCorteCaja}>
                                        <TableCell align='center'>
                                            {`${row.TotalMovimientos}`}
                                        </TableCell>
                                        <TableCell align='center'>
                                            {`${formatDinero(row.TotalMXN)}`}
                                        </TableCell>
                                        <TableCell align="center">
                                            {`${formatDinero(row.TipoCambio)}`}
                                        </TableCell>
                                        <TableCell align="center">
                                            {`${formatDinero(row.TotalUSD)}`}
                                        </TableCell>
                                        <TableCell align="center">
                                            {`${formatDinero(row.Ganancia)}`}
                                        </TableCell>
                                        <TableCell align="center">
                                            {`${FormatoFechaIso({ date: row.FechaRegistro, formato: "dd-MM-yyyy" })}`}
                                        </TableCell>
                                        <TableCell align="center">
                                            <DBCorte idCorte={row.IdCorteCaja} />
                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={rows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
            <BackDrop open={load} />
        </div>
    )
}
export default TCortes